import React, { PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { ThemeProvider } from '@material-ui/core/styles';

import { darkTheme, theme } from '../../themes';
import Apologies from '../apologies';
import { Toaster } from '../toaster/Toaster';
import { usePageTitles } from '../../hooks/usePageTitles';

import type { RootState } from '../../types/state.types';

export const AppRoot: React.FC<PropsWithChildren<RouteComponentProps<{}, any>>> = ({
  children,
  params,
}) => {
  const darkModeActive = useSelector((state: RootState) => state.theme.dark);

  usePageTitles(params);

  return (
    <ThemeProvider theme={darkModeActive ? darkTheme : theme}>
      <div className="app-root">
        {children}
        <Apologies />
        <Toaster />

        <div id="busyIndicator" style={{ display: 'none' }}>
          Loading...
        </div>
        <div id="busyIndicatorShowCounter" style={{ display: 'none' }} />
      </div>
    </ThemeProvider>
  );
};
